export default __webpack_public_path__ + "static/media/prize.21f2250b.png";